import { BoardParameter } from '../../../../model/board-parameters';
import { IVariable } from '../../model/variable';

export class Variable {
  private _name: string;
  private _parameter?: BoardParameter;
  private _referenceValue: number;
  private _unit: string;
  private _value: number;
  private _variable: IVariable;

  get name(): string {
    return this._name;
  }

  get referenceValue(): number {
    return this._referenceValue;
  }

  get unit(): string {
    return this._unit;
  }

  get value(): number {
    return this._value;
  }

  constructor(value: IVariable, parameter?: BoardParameter, initialValue?: number) {
    this._variable = value;
    this._parameter = parameter;
    this._name = value.variable;
    this._unit = value.unitOfMeasure;

    // need to asssure that the parameter.value actually is of type Number, otherwise computations will break
    this._referenceValue = parameter && parameter.value !== undefined ? Number(parameter.value) : 0;
    this._value = initialValue ?? this._referenceValue;
  }

  alterValue(diff: number): void {
    this._value += diff;
  }

  resetParameter(): void {
    this._value = this._referenceValue;
  }

  clone(): Variable {
    return new Variable(this._variable, this._parameter, this.value);
  }
}
